import React from "react"

import logo from "../../assets/go-logo.svg"

const Logo = () => {
   return <img src={logo} alt={"logo"} className="max-h-8" />
}

export default Logo
